import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    let header = (<a href="#/localMerchant/home">我的店铺</a>,
    <a href="#/localMerchant/myShop">商家等级</a>,
    <a href="#/localMerchant/myShop/regular">等级规则</a>,
    '套餐')

    return (
      <HeaderView title="套餐" header={header}>
        <div style={{ padding: '20px 40px' }}>
          <img src="http://qnm.hunliji.com/o_1aa3d049mm8j15o1g7fqhspgi1u.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa3d049mar368dnc61mjn1ia91v.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa3d049m1tf51h1j1iftt8u1fjm20.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa3d049menb3eeklqqtn1buh21.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa3d049m5euie22ee17me1md422.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa3d049m12181b8f1oil1bh2n6v23.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa3d049mm181qls18rl1ga71qf724.jpg" />
        </div>
      </HeaderView>
    )
  }
}
